export default "__VITE_ASSET__DMMOUQHI__"